import { render, staticRenderFns } from "./gallery.global.vue?vue&type=template&id=12312000&"
import script from "./gallery.global.vue?vue&type=script&lang=js&"
export * from "./gallery.global.vue?vue&type=script&lang=js&"
import style0 from "./gallery.global.vue?vue&type=style&index=0&id=12312000&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports